export const de = {
  // Common
  conversation: 'Unterhaltung',
  connected: 'Verbunden',
  disconnected: 'Getrennt',
  loading: 'Lädt...',
  error: 'Fehler',
  
  // Welcome messages
  welcomeMessage: 'Hallo, wie kann ich Ihnen heute helfen?',
  joinedChat: 'ist dem Chat beigetreten',
  
  // Chat actions
  createNewChat: 'Eine neue Unterhaltung erstellen',
  newConversation: 'Neue Unterhaltung',
  moreResults: 'Ich möchte mehr Ergebnisse',
  
  // Input placeholders
  inputPlaceholder: 'Nachricht eingeben...',
  inputPlaceholderGenerating: 'Ergebnisse werden generiert...',
  
  // Loading messages
  collectingInfo: 'Sammle notwendige Informationen ...',
  searchingBestResults: 'Suche nach den besten Ergebnissen ...',
  analyzingDatabase: 'Analysiere Datenbank für Suche ...',
  checkingSpecialOffers: 'Prüfe verfügbare Sonderangebote ...',
  searchingSimilarProducts: 'Suche nach ähnlichen Produkten ...',
  preparingRecommendations: 'Bereite personalisierte Empfehlungen vor ...',
  checkingStock: 'Prüfe Lagerbestand und Produktverfügbarkeit ...',
  finalizingResponse: 'Finalisiere Antwort mit den relevantesten Optionen ...',
  
  // Thinking steps
  analyzingRequest: 'Analysiere Ihre Anfrage ...',
  generatingSearchTerms: 'Generiere Suchbegriffe ...',
  processingSearchTerms: 'Verarbeite Suchbegriffe ...',
  searchingDatabase: 'Durchsuche Datenbank nach geeigneten Produkten ...',
  processingResults: 'Verarbeite gefundene Ergebnisse ...',
  generatingEstimates: 'Generiere Zeit- und Kostenschätzungen ...',
  generatingFinalResponse: 'Generiere finale Antwort ...',
  processingRequest: 'Findly denkt nach ...',
  
  // Status messages
  waitingPreviousResults: 'Warte auf vorherige Unterhaltungsergebnisse ...',
  checkingContinuation: 'Prüfe ob Unterhaltung fortgesetzt werden kann...',
  
  // Empty states
  noMessagesYet: 'Noch keine Nachrichten',
  
  // Error messages
  failedCreateChat: 'Fehler beim Erstellen eines neuen Chats. Bitte versuchen Sie es erneut.',
  errorCreatingChat: 'Fehler beim Erstellen des Chats',
  errorSendingMessage: 'Fehler beim Senden der Nachricht',
  errorLoadingChats: 'Fehler beim Laden der Chats',
  
  // Cart messages
  productAddedToCart: 'Produkt {{productCode}} wurde zum Warenkorb hinzugefügt!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Verbunden 🟢',
  connectionStatusDisconnected: 'Getrennt 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: 'Ich kann Ihnen helfen, die Produkte zu finden, die Sie suchen!',
  chatEncouragement2: 'Brauchen Sie Hilfe beim Finden von etwas Speziellem?',
  chatEncouragement3: 'Lassen Sie mich Ihnen beim Einkaufen helfen!'
};
